<template>
  <div class="page-container">
    <div class="dashboard-container">
      <div class="page-card">
        <div class="page-card-body">
          <div class="descriptions">
            <div class="descriptions-header">
              <div class="descriptions-title" style="font-size: 20px;line-height: 28px;">欢迎访问 {{ app_name }}</div>
              <div style="min-width: 220px;text-align: right;">
                <el-button size="medium" type="default" @click="showRestPdDialog">修改密码</el-button>
                <el-button size="medium" type="default" @click="logout">退出登录</el-button>
              </div>
            </div>
          </div>
          <el-row :gutter="24">
            <el-col :span="6" :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <div class="index-card">
                <div class="index-card-header">
                  <img src="@/assets/index-title-icon.png" alt="" class="icon">
                  <span>我的信息</span>
                </div>
                <div class="index-card-content information">
                  <div class="information-row">
                    <div class="label">姓&ensp;&ensp;&ensp;&ensp;名：</div>
                    <div class="value">{{ user.realname }}</div>
                  </div>
                  <div class="information-row">
                    <div class="label">用&ensp;户&ensp;名：</div>
                    <div class="value">{{ user.username }}</div>
                  </div>
                  <div class="information-row">
                    <div class="label">手&ensp;机&ensp;号：</div>
                    <div class="value">{{ user.mobile || '-' }}</div>
                  </div>
                  <div class="information-row">
                    <div class="label">邮&ensp;&ensp;&ensp;&ensp;箱：</div>
                    <div class="value">{{ user.email || '-' }}</div>
                  </div>
                  <div class="information-row">
                    <div class="label">注册时间：</div>
                    <div class="value">{{ user.created_at }}</div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="18" :xs="24" :sm="12" :md="12" :lg="18" :xl="18">
              <div class="index-card">
                <div class="index-card-header">
                  <img src="@/assets/index-title-icon.png" alt="" class="icon">
                  <span>操作中心</span>
                </div>
                <div class="index-card-content operation-menu">
                  <div class="operation-item-wrap" v-if="user && user.is_supper_admin">
                    <div class="operation-item" @click="goPage('/admins')">
                      <img src="@/assets/index-menu-1.png" alt="" class="icon">
                      <div class="label">用户管理</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_car_permission">
                    <div class="operation-item" @click="goPage('/car')">
                      <img src="@/assets/index-menu-2.png" alt="" class="icon">
                      <div class="label">汽车大屏</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_car_permission">
                    <div class="operation-item" @click="goPage('/car/setting')">
                      <img src="@/assets/index-menu-3.png" alt="" class="icon">
                      <div class="label">汽车参数</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_bus_permission">
                    <div class="operation-item" @click="goPage('/bus')">
                      <img src="@/assets/index-menu-4.png" alt="" class="icon">
                      <div class="label">客车大屏</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_bus_permission">
                    <div class="operation-item" @click="goPage('/bus/setting')">
                      <img src="@/assets/index-menu-5.png" alt="" class="icon">
                      <div class="label">客车参数</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_c8m_permission">
                    <div class="operation-item" @click="goPage('/c8m')">
                      <img src="@/assets/index-menu-6.png" alt="" class="icon">
                      <div class="label">C8M大屏</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                  <div class="operation-item-wrap" v-if="user && user.has_c8m_permission">
                    <div class="operation-item" @click="goPage('/c8m/setting')">
                      <img src="@/assets/index-menu-7.png" alt="" class="icon">
                      <div class="label">C8M参数</div>
                      <div class="notice">点击进入</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="show_reset_pd_dialog" :close-on-click-modal="false" width="30%" center>
      <el-form ref="reset" :model="resetPdModel" :rules="resetPaRules"
               label-width="120px" style="max-width: 960px;">
        <el-form-item label="原密码" prop="old_password">
          <el-input type="password" v-model="resetPdModel.old_password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input type="password" v-model="resetPdModel.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_password">
          <el-input type="password" v-model="resetPdModel.confirm_password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="resetPdSubmit('reset')">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {APP_NAME} from "@/utils/config"
import {resetPwd} from "@/api/auth";

export default {
  name: "Index",
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value == this.resetPdModel.password) {
        callback()
      } else {
        callback(new Error('确认密码不一致'))
      }
    }
    return {
      app_name: APP_NAME,
      // 修改密码
      show_reset_pd_dialog: false,
      resetPdModel: {
        old_password: '',
        password: '',
        confirm_password: ''
      },
      resetPaRules: {
        old_password: [
          {required: true, message: '请输入原密码', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {min: 6, message: '最少6位字符', trigger: 'blur'},
        ],
        confirm_password: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {min: 6, message: '最少6位字符', trigger: 'blur'},
          {validator: validateConfirmPassword, trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    goPage(path) {
      this.$router.push(path)
    },
    logout() {
      let that = this
      that.$alert(
        '确定要退出登录吗？',
        '退出确认',
        {
          confirmButtonText: '确定',
          callback: action => {
            if (action === 'confirm') {
              that.$store.dispatch('auth/logout').then(() => {
                that.$router.replace('/login')
                that.$message.success("退出成功")
              })
            }
          }
        });
    },
    //修改密码
    showRestPdDialog() {
      let that = this
      that.resetPdModel = {
        old_password: '',
        password: '',
        confirm_password: '',
      }
      that.show_reset_pd_dialog = true
    },
    resetPdSubmit(ref) {
      let that = this
      that.$refs[ref].validate((valid) => {
        if (!valid) return false
        resetPwd(that.resetPdModel.old_password, that.resetPdModel.password).then(() => {
          that.$message.success("重置成功")
          that.show_reset_pd_dialog = false
          that.$store.dispatch('auth/logout').then(() => {
            that.$router.replace('/login')
          })
        }).catch(err => {
          console.log('重置密码失败', err)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.index-card {
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EEEEEE;

  .index-card-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 72px;
    padding: 0 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #18191A;
    line-height: 24px;

    .icon {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }

  .index-card-content {
    padding: 0 24px 24px 24px;
  }
}

.information {
  .information-row {
    width: 100%;
    height: 38px;
    padding: 0 16px;
    background: #F6F6F6;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #2F3133;

    & + .information-row {
      margin-top: 16px;
    }
  }
}

.operation-menu {
  padding: 0 12px !important;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .operation-item-wrap {
    width: 20%;
    min-width: 250px;
    padding: 0 12px;
  }

  .operation-item {
    cursor: pointer;
    width: 100%;
    min-width: 236px;
    height: 254px;
    background-color: #FFFFFF;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
    margin-bottom: 24px;

    .icon {
      width: 100px;
      height: 100px;
    }

    .label {
      height: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #18191A;
      line-height: 24px;
      text-align: center;
      margin-top: 10px;
    }

    .notice {
      margin-top: 34px;
      height: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #8D9094;
      line-height: 22px;
      text-align: center;
      visibility: hidden;
    }

    &:hover {
      border: 1px solid #17A6BF;
      box-shadow: 0 2px 12px 0 rgba(23, 166, 191, .1);

      .label {
        color: #17A6BF;
      }

      .notice {
        visibility: visible;
      }
    }
  }
}
</style>
